export default {
  methods: {
    getRedirectMetaDescription() {
      switch (this.$route.query.redirectTo) {
        case '/kelas-online':
          return 'Pahamilah perubahan cewek atau putri anda dengan mengikuti kelas online dari Charm. Yuk, girls dan parents cari tahu hal seputar pubertas di sini!'
        case '/kuis-mitos-fakta':
          return 'Banyak banget fakta mitos seputar menstruasi ya, Charm Girls. Bener nggak sih pas menstruasi nggak boleh keramas? Yuk ikuti kuis ini untuk mengetahui jawabannya!'
        case process.env.charm360URL:
          return 'Halo, Charm Girls! Selamat datang di Charm Girl’s Talk. Di sinilah tempat membahas menstruasi dan seputar cewek dengan cara FUN. Yuk kunjungi websitenya!'
      }
    },
  },
}
